











import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { ProductTabFilterOptions, PageConfig } from "../../types";
import ProductTable from "../ProductTable.vue";
import SKUNameRenderer from "../TableRenderers/SKUNameRenderer.vue";
import TableActionAddRenderer from "../TableRenderers/TableActionAddRenderer.vue";
import { encodeQueryParams } from "@canvas/api/lib/utils";
import NameRenderer from "../TableRenderers/NameRenderer.vue";

export default Vue.extend({
  name: "manage-products",
  components: {
    ProductTable
  },
  data() {
    return {
      searchData: {
        text: "",
        option: ""
      },
      searchFilter: {},
      skuTableColumns: [
        {
          name: "sku_name",
          display_name: "PRODUCT NAME",
          fixed: false,
          width: 40,
          headrenderer: null,
          cellrenderer: SKUNameRenderer
        },
        {
          name: "sku_code",
          display_name: "PRODUCT CODE",
          sortable: false,
          fixed: false,
          width: 30,
          headrenderer: null,
          cellrenderer: NameRenderer
        },
        {
          name: "action",
          display_name: "",
          fixed: false,
          width: 30,
          headrenderer: null,
          cellrenderer: TableActionAddRenderer
        }
      ]
    };
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement"
    }),
    ...mapState("appModule", {
      selectedEc: "selectedEc",
      skuTableData: "productSearchResultsTable"
    })
  },
  provide(): any {
    return {
      actionHandler: this.handleTableAction
    };
  },
  methods: {
    ...mapActions("appModule", ["searchCmsProducts"]),
    handleTableAction(actionType: string, data: any) {
      switch (actionType) {
        case "rowselect":
        case "add":
          this.$emit("updateRoute", { to: "finish", data: data });
          break;
        case "pageIncrease":
        case "pageDecrease":
        case "goToPage":
          this.skuTableData.pageConfig.offset =
            this.skuTableData.pageConfig.limit * (data - 1);
          this.skuTableData.pageConfig.page = data;
          this.updateRoute();
          break;
        case "setPageLength":
          this.skuTableData.pageConfig.limit = data;
          this.skuTableData.pageConfig.page = 1;
          this.skuTableData.pageConfig.offset = 0;
          this.updateRoute();
          break;
      }
    },
    updateRoute() {
      //update the url params so that on reload user's required page is fetched
      const query = {
        filters: this.searchFilter,
        start: this.skuTableData.pageConfig.offset,
        count: this.skuTableData.pageConfig.limit
      };
      this.skuTableData.pageConfig.query = encodeQueryParams(query);
      const routeLink =
        "/" +
        this.selectedEc.name +
        "/add/" +
        JSON.stringify({
          search: this.searchData,
          filters: this.searchFilter,
          pageConfig: this.skuTableData.pageConfig
        });
      this.$router.push({
        path: routeLink
      });
    },
    searchProduct() {
      this.searchCmsProducts(this.skuTableData.pageConfig);
    },
    initProductSearch() {
      const parsedJSONData = JSON.parse(
        this.$router.currentRoute.params.searchQuery
      );
      this.searchData = parsedJSONData.search ? parsedJSONData.search : {};
      this.searchFilter = parsedJSONData.filters ? parsedJSONData.filters : {};
      this.skuTableData.pageConfig = parsedJSONData.pageConfig
        ? parsedJSONData.pageConfig
        : PageConfig;
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
    if (to.path !== from.path) {
      this.initProductSearch();
      this.searchProduct();
    }
  },
  mounted() {
    this.initProductSearch();
  }
});
